import React from 'react';
import './Agenda.css';
import VideoPresent from './VideoPresent/VideoPresent';
import Vautier from '../../img/agenda/Vautier.png'
import Azqore from '../../img/agenda/Azqore.png'
import Laiso from '../../img/agenda/Laiso.png'
import Hotjar from '../../img/agenda/Hotjar.png'
import Oscurato from '../../img/agenda/Oscurato.png'
import Indigo from '../../img/agenda/indigo.png'
import Gautam from '../../img/agenda/Gautam.png'
import Mfable from '../../img/agenda/Mfable.png'

export default class Agenda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [
              {
                  id: 1,
                  time: '10:10',
                  photo: Vautier,
                  name: 'Benjamin Vautier',
                  position: 'Design Director',
                  ln: 'https://www.linkedin.com/in/benjaminvautier/?locale=en_US',
                  logo: Azqore,
                  title: 'The importance of research on field and the relevancy of testing along the design journey',
                  abstract: `When I first start my designer journey, I was sure that UX was the key of everything. Just because it owns different methods somehow the craft based on data.

                  Later, after few years of good deeds as UX, I worked on complex projects and I understood somehow that research should always be on the field, with real people in their own environment. I also figured that interviews were more tangible if the discussion was around something real, such as a prototype or a POC. It was faster and more efficient to get to a good result! That why in almost all my projects, with my teams I go on site and talk to people, shadow them to understand everything, and when I have something to share with end users, I run tests.
                  
                  In this talk I will share with you real insights and exemples to understand the importance of the design research on the field and why running tests asap is always better. And how I have been doing this!`,
              },
              {
                  id: 2,
                  time: '10:40',
                  photo: Laiso,
                  name: 'Alessio Laiso',
                  position: 'Senior Product Designer',
                  ln: 'https://www.linkedin.com/in/alessiolaiso',
                  tw: 'https://twitter.com/alessiolaiso',
                  github: 'https://github.com/AlessioLaiso',
                  logo: Hotjar,
                  title: 'Interacting with words: can typography improve user experience?',
                  abstract: `This talk is divided in 2 parts: after going through the various stages of the design of a typeface from the perspective of a type designer, we reflect on the results of various studies highlighting how typography and font selection deeply influence how users perceive and interact with digital products.`,
              },
              {
                  id: 3,
                  time: '11:10',
                  photo: Oscurato,
                  name: 'Roberto Oscurato',
                  position: 'UX Designer',
                  ln: 'https://www.linkedin.com/in/roberto-oscurato-593231bb/',
                  logo: Indigo,
                  title: 'Conversational UX Design approach',
                  abstract: `Today, conversational design is gaining ground as a relevant discipline among the various UX proposals, but what does it mean to be involved in conversational design? Let's take a look at the approach used by a company that has been working on building meaningful conversational experiences by combining artificial intelligence technologies with design.`,
              },
              {
                  id: 4,
                  time: '11:40',
                  photo: Gautam,
                  name: 'Prasanta Gautam',
                  position: 'Founder and Principal Designer',
                  ln: 'https://www.linkedin.com/in/pkgautam/',
                  logo: Mfable,
                  title: 'Getting started with UX Design for AR & VR',
                  abstract: `With our world becoming increasingly digital and the consumer buying patterns dramatically changing, it’s crucial for our products and services to evolve faster to stay abreast. To stay at par with this change, it’s necessary for organizations to pay attention to how the customer interacts with their product, service, and brand. So building the relevant product/service is the need of the hour. 

                  As a designer myself I understand how the influence of design-led approach can bring positive output across the business functions.  So, having the right set of skills and tools is paramount.
                  
                  So, in this talk I’ll like to throw some light on the relevance of design in the ever evolving field of Augmented Reality & Virtual Reality. I’ll give an overview of the field to anyone who wants to kick start their career in AR & VR design. This is very suitable for beginners, newbies & amateurs in the field of AR & VR. 
                  
                  So, in a nutshell listeners will learn about the following
                  •        Overview of AR & VR
                  •        Types of AR & VR
                  •        UX processes for AR & VR
                  •        Research methods, Prototyping, and User testing 
                  •        Tools & devices used in AR & VR
                  •        Challenges of 3D Interaction design`,
              },
          ],
        }
      }

    render() {
        return (
            <div className="agenda" id='agenda'>
                <div className='container agenda'>
                    <h3 className="agenda_title">Agenda</h3>
                    <p className="agenda_undertitle">Time zone 0 UTC</p>
                    <p className="agenda_undertitle">February 10 10:00 - 23:30</p>
                    <p className="agenda_day">Junior Day</p>
                    <VideoPresent speakers={this.state.list}/>
                    <a className='full_agenda_btn' href='https://geekle.us/schedule/ui' target='_blank' rel="noreferrer">SHOW FULL AGENDA</a>
                </div>
            </div>
        );
    }
};